import Styled from 'styled-components';

const CommunicationPage = Styled.div`
    min-height: 100%;
    overflow-x: hidden;
    background: #f6f7fb;

    @media only screen and (max-width: 767px){
        .ant-card-toolbox,
        .ant-page-header{
            padding: 16px 16px 8px;
            background: #f6f7fb;
        }
        .ant-page-header-heading{
            display: flex !important;
            flex-flow: row wrap !important;
            align-items: center !important;
            justify-content: space-between !important;
            gap: 12px;
        }
        .ant-page-header-heading-left{
            min-width: 0;
            margin: 0 !important;
            width: 100% !important;
        }
        .ant-page-header-heading-title{
            font-size: 22px;
            line-height: 1.25;
            color: #20253a;
            font-weight: 700;
            white-space: normal !important;
            word-break: break-word !important;
            overflow-wrap: anywhere !important;
            text-align: left !important;
        }
        .ant-page-header-heading-extra{
            float: none;
            margin: 0 !important;
            display: block !important;
            width: 100% !important;
        }
        .page-header-actions{
            display: flex;
            align-items: center;
            flex-wrap: wrap;
            gap: 8px;
            width: 100%;
        }
        .page-header-actions .ant-btn{
            height: 36px;
            padding: 0 14px;
            border-radius: 6px !important;
            font-size: 13px;
        }
        .ant-breadcrumb{
            display: flex;
            min-width: 0;
            overflow-x: auto;
            white-space: nowrap;
        }
        .communication-main{
            min-height: 0;
            width: 100%;
            padding: 12px 16px 24px;
            box-sizing: border-box;
            background: #f6f7fb;
        }
        .communication-main .ant-card{
            width: 100%;
            overflow: hidden;
            border: 1px solid #edf0f5;
            border-radius: 10px !important;
            background: #fff;
            box-shadow: 0 4px 12px rgba(31, 39, 79, 0.04);
            margin-bottom: 14px !important;
        }
        .communication-main .ant-card-head{
            min-height: 52px;
            padding: 0 16px;
        }
        .communication-main .ant-card-head-title{
            padding: 14px 0;
            font-size: 16px;
            font-weight: 700;
            text-align: left !important;
        }
        .communication-main .ant-card-extra{
            max-width: 100%;
            padding: 10px 0;
            float: none;
        }
        .communication-main .ant-card-extra > .ant-space{
            display: flex;
            width: 100%;
            flex-wrap: wrap;
            gap: 8px !important;
        }
        .communication-main .project-sort-bar{
            width: 100%;
            border: 1px solid #e3e6ef;
            border-radius: 6px;
            background: #ffffff;
        }
        .communication-main .ant-card-extra .ant-space-item:has(.project-sort-nav){
            width: 100%;
            min-width: 0;
            max-width: 100%;
            overflow: visible !important;
        }
        .communication-main .project-sort-nav{
            display: block;
            width: 100%;
            min-width: 0;
            max-width: 100%;
            overflow-x: scroll !important;
            overflow-y: hidden;
            -webkit-overflow-scrolling: touch;
        }
        .communication-main .project-sort-nav nav{
            display: block;
            width: max-content;
            min-width: 100%;
            background: #ffffff;
            border-radius: 6px;
            padding: 6px 16px;
            border: 0;
            box-shadow: none;
        }
        .communication-main .project-sort-nav nav ul{
            display: flex;
            width: max-content;
            min-width: 100%;
            align-items: center;
            justify-content: flex-start;
            margin: 0;
            padding: 0;
            list-style: none;
            flex-wrap: nowrap;
        }
        .communication-main .project-sort-nav nav ul li{
            margin-right: 14px;
            padding-right: 14px;
            border-right: 1px solid #e3e6ef;
            flex: none;
        }
        .communication-main .project-sort-nav nav ul li:last-child{
            margin-right: 0;
            padding-right: 0;
            border-right: 0 none;
        }
        .communication-main .project-sort-nav nav ul li a{
            display: inline-block;
            color: #8c90a4;
            font-weight: 400;
            font-size: 14px;
            padding: 0;
            background: transparent !important;
            border-radius: 0 !important;
            white-space: nowrap;
        }
        .communication-main .project-sort-nav nav ul li.active a{
            color: #5f63f2 !important;
            font-weight: 500;
            background: transparent !important;
        }
        .communication-main .table-responsive{
            width: 100%;
            overflow-x: visible;
        }
        .communication-main .ant-table-wrapper,
        .communication-main .ant-spin-nested-loading,
        .communication-main .ant-spin-container{
            width: 100%;
            max-width: 100%;
        }
        .communication-main .ant-table{
            width: 100%;
        }
        .communication-main .ant-table-content{
            overflow-x: auto !important;
            -webkit-overflow-scrolling: touch;
        }
        .communication-main .ant-table-content table{
            min-width: 720px !important;
        }
        .communication-main .ant-table-container{
            border: 1px solid #edf0f5;
            border-radius: 0;
        }
        .communication-main .ant-table-thead > tr > th{
            padding: 12px 14px;
            background: #f7f8fa;
            color: #424863;
            font-size: 12px;
            font-weight: 700;
            white-space: nowrap;
        }
        .communication-main .ant-table-tbody > tr > td{
            padding: 12px 14px;
            color: #303750;
            font-size: 13px;
            vertical-align: middle;
        }
        .communication-main .ant-table-tbody > tr > td .ant-space{
            gap: 8px !important;
        }
        .communication-main .ant-table-tbody > tr > td .ant-btn{
            height: 36px;
            padding: 0 16px;
            font-size: 13px;
            border-radius: 40px !important;
        }
        .request-callback-main .table-responsive{
            overflow: hidden;
        }
        .request-callback-main .ant-table-container{
            overflow: visible;
        }
        .request-callback-main .ant-table-content{
            display: block;
            width: 100%;
            max-width: 100%;
            overflow-x: scroll !important;
            overflow-y: hidden;
            -webkit-overflow-scrolling: touch;
            touch-action: pan-x;
        }
        .request-callback-main .ant-table-content table{
            width: max-content !important;
            min-width: 1280px !important;
            table-layout: auto !important;
        }
        .request-callback-main .ant-table-cell-fix-left,
        .request-callback-main .ant-table-cell-fix-right,
        .request-callback-main [class*='ant-table-cell-fix']{
            position: static !important;
            top: auto !important;
            right: auto !important;
            bottom: auto !important;
            left: auto !important;
            z-index: auto !important;
            float: none !important;
            box-shadow: none !important;
        }
        .communication-main .communication-table .ant-table{
            width: 100% !important;
            min-width: 0 !important;
        }
        .communication-main .communication-table .ant-table-content table{
            min-width: 500px !important;
            table-layout: fixed;
        }
        .communication-main .communication-table{
            overflow-x: auto !important;
            -webkit-overflow-scrolling: touch;
        }
        .communication-main .communication-table .ant-table-content{
            overflow-x: auto !important;
            -webkit-overflow-scrolling: touch;
        }
        .communication-main .communication-table .ant-table-content table{
            width: max-content !important;
            min-width: 100% !important;
        }
        .communication-main .communication-table .ant-table-cell-fix-left,
        .communication-main .communication-table .ant-table-cell-fix-right,
        .communication-main .communication-table [class*='ant-table-cell-fix']{
            position: static !important;
            top: auto !important;
            right: auto !important;
            bottom: auto !important;
            left: auto !important;
            z-index: auto !important;
            float: none !important;
            box-shadow: none !important;
        }
        .communication-main .ant-pagination{
            display: flex;
            flex-wrap: wrap;
            justify-content: center;
            margin: 14px 8px;
        }
        .ant-drawer-content-wrapper,
        .ant-drawer-right .ant-drawer-content-wrapper{
            width: 100% !important;
            max-width: 100% !important;
        }
        .ant-modal{
            max-width: calc(100vw - 32px);
        }
        .call-history-main .call-history-filters{
            display: flex;
            width: 100%;
            flex-wrap: wrap;
            gap: 8px !important;
            margin-bottom: 12px !important;
        }
        .call-history-main .call-history-filters .ant-select,
        .call-history-main .call-history-filters .ant-space-item{
            width: 100% !important;
        }
        .call-history-main .call-history-filters .ant-btn{
            width: 100%;
            min-height: 40px;
        }
        .call-history-details-panel{
            width: calc(100vw - 16px) !important;
            max-width: calc(100vw - 16px) !important;
        }
        .call-history-details-panel .ant-drawer-header{
            padding: 16px;
        }
        .call-history-details-panel .ant-drawer-body{
            padding: 16px;
            overflow-x: hidden;
        }
        .call-history-details-panel .ant-row > .ant-col{
            width: 100%;
            max-width: 100%;
            flex: 0 0 100%;
        }
        .call-history-details-panel .ant-typography,
        .call-history-details-panel .ant-collapse-header,
        .call-history-details-panel .ant-collapse-content-box{
            overflow-wrap: anywhere;
            word-break: break-word;
        }
        .call-history-details-panel .ant-space{
            max-width: 100%;
        }
        .inbox-main > .inbox-layout > .ant-col{
            width: 100%;
            max-width: 100%;
            flex: 0 0 100%;
        }
        .inbox-main .inbox-chat-column{
            min-width: 0;
        }
        .inbox-main .inbox-contacts-column{
            margin-bottom: 16px;
        }
        .inbox-main .inbox-contacts-column > div{
            height: min(60vh, 520px);
            min-height: 0;
            max-width: 100%;
            margin: 0;
        }
        .inbox-main .inbox-contacts-column .ant-card{
            height: 100%;
            display: flex;
            flex-direction: column;
        }
        .inbox-main .inbox-contacts-column .ant-card-body{
            display: flex;
            flex: 1;
            min-height: 0;
            flex-direction: column;
        }
        .inbox-main .inbox-contacts-column .ant-card-body > div:last-child{
            height: auto !important;
            min-height: 0;
            flex: 1;
        }
        .inbox-main .inbox-chat-column{
            clear: both;
            margin-top: 0;
        }
        .inbox-main .ant-card-body{
            padding: 12px !important;
        }
        .inbox-main .ant-card .ant-card{
            border-top-width: 1px;
            box-shadow: none;
        }
        @media only screen and (max-width: 575px){
            .inbox-main{
                padding: 8px 12px 24px;
            }
            .inbox-layout--chat-open .inbox-chat-column{
                display: block;
                width: 100%;
                max-width: 100%;
                flex: 0 0 100%;
            }
        }
        .notification-templates-main .ant-row > .ant-col{
            width: 100%;
            max-width: 100%;
            flex: 0 0 100%;
        }
        .notification-templates-main .ant-card-cover img{
            height: 140px !important;
            object-fit: cover;
        }
        .ant-modal,
        .ant-drawer{
            max-width: calc(100vw - 24px);
        }
    }
`;

export { CommunicationPage };
